import { EventEmitter, Injectable } from '@angular/core';
import { ApiService } from 'src/app/api.service';
import { BehaviorSubject, Subject } from 'rxjs';
import { Operation } from 'src/app/models/operation';
import { Model } from 'src/app/models/model';
import { ValoresLiquidativos } from 'src/app/models/valoresliquidativo';
import { operationinterface } from 'src/app/interface/OperationInterface';
import { valorlatenteinterface } from 'src/app/interface/ValorLatenteInterface';
import { rendimientoanualinterface } from 'src/app/interface/RendimientoAnualInterface';
import { tablainterface } from 'src/app/interface/TablaInterface';
import { OptimalWallet } from 'src/app/interface/OptimalWallet';
import { distinctUntilChanged } from 'rxjs/operators';

export interface Interfaceformdata{
    condicion: string,
    fechaInicio: string,
    bajista: boolean,
    stoploss:number,
    period: number,
    tipo: string,
    idMercado:string,
    sectype:string,
    periodoModeloPeriodico:number,
    porcentajeprima: string,
    profit: number, 
    stoplossCheck: boolean,
    stoplossDinamicCheck: boolean,
    diasSalida: number,
    diasSalidaCheck: boolean,
    salidaFinDiaCheck: boolean,
    profitCheck: boolean,
metaapi?: boolean,
}

@Injectable({
    providedIn: 'root',
})
export class PlanificadorService {
    public indicatorsIaSinEspacios: string[] = [];
    
    constructor(private apiService: ApiService) { }
    public noCondiciones: boolean = false;
    public orderActivities = new EventEmitter<GestionInterface[]>();
    public loadModel = false;
    public loadingModel = false;
    public errorModel: any = false;
    public condiciones: string[][] = [];
    public interpretacionDataListEntry:any[] = []; //
    public interpretacionDataListExit:any[] = []; //

    // `condiciones` ([texto visible, tipo, original]) es la única fuente de verdad: las listas
    // entry/exit que usa el backend se derivan de ella en vez de mantenerse a mano con splice.
    // Si item[2] no es string es una condición legada guardada como objeto y se conserva tal cual.
    sincronizarListasCondiciones(): void {
        this.interpretacionDataListEntry = [];
        this.interpretacionDataListExit = [];
        for (const c of this.condiciones) {
            const valor: any = typeof c[2] === 'string' ? c[0] : c[2];
            if (c[1] === 'Salida') this.interpretacionDataListExit.push(valor);
            else this.interpretacionDataListEntry.push(valor);
        }
    }

    showIndice: boolean = false;
    showVolatilidad: boolean = false;
    idActivoIndice: number = 0;
    nombreActivoIndice: string = '';
    idnombreActivosIndice: any[] = [];
    idActivoVolatilidad: number = 0;
    nombreActivoVolatilidad: string = '';
    idnombreActivosVolatilidad: any[] = [];
     public formdata = new BehaviorSubject <any>({
        condicion: '',
        fechaInicio: '2010-01-01',//'2020-01-0
        bajista: false,
        stoploss: 20,
        profit: 20,
        period: 6,
        tipo: 2,//obviar
        idMercado: 8,//8
        periodoModeloPeriodico: -1,
        porcentajeprima: 0,
    });

    public formData2 : FormDataInterface = {
        condicion: '$Close0[0] > $MH0[1]',
        fechaInicio: '2010-01-01',
        bajista: false,
        stoploss: 20,
        profit: 20,
        period: 6,
        tipo: 2,
        idMercado: 21,
        periodoModeloPeriodico: -1,
        porcentajeprima: 0,
    };

    optimalWallet  = new BehaviorSubject<OptimalWallet>({
        apalancamiento: 1,
        bajista: false,
        capitalinicial: 100000.0,
        idcartera: 0,
        nombre: '',
        valorLiquidativo: 100000,
        valorliquidativoTemp: 0.0,
        riesgomaximo: 50.0,
        tipocuenta: 'MARGEN',
        tiporiesgo: 'LIMITADO',
        riesgo: 1000.0,
        comisionbroker: 10.0,
        idmercado: 0,
        intervalotiempo: 2,
        prima: false,
        participacion: false,
        simulado: true,
        poderCompra: 100000,
        numeroReconfiguracion: 0,
        stopLoss: 20,
        profit: 10,
        capitales:[ 1000.0, 1000.0],
        fondosDisponibles: 100000,
        margen: 0,
        margenRequeridoPor: 30,
        controlMarginCall: 75.0,
        lista: 0,
        nOperaciones: 0,
        maxDiferenciaCierres: 0.0,
        rendimientoNeto: 0.0,
        rendimientomedioanual: 0.0,
        rendimientoacumuladoanual: 0.0,
        tasacrecimientoanualcompuesto: 0.0,
        periodosoperativa: 0,
        beneficioneto: 0.0,
        beneficionetoporcentual: 0.0,
        mayorretrocesodesdemaximo: 0.0,
        mayorretrocesodesdemaximoporcentual: 0.0,
        mediabeneficioperdidaporcentual: 0.0,
        sumaresiduosbeneficioperdidaporcentual: 0.0,
        volatilidadperiodo: 0.0,
        volatilidadanual: 0.0,
        mesesdd: 0,
        maximoretrocesoperiodo: 0.0,
        sumarrendimientosanuales: 0.0,
        prombeneficiointervalo: 0.0,
        prombeneficionintervaloporcentual: 0.0,
        sumatorio: false,
        coeficientevolatilidadanual: 1.0,
        ratiobeneficioriesgo: 0.0,
        modelodesde: '',
        efectivo: 100000.0,
        gastosGestionPor: 1.0,
        gastosPrestamoPor: 8.0,
        nRecalcular: 0,
        idModelo: 0,
        liquidativos: null,
        sincro: true,auto:false,
        idCarteras:[0,0,0,0,0],
        subCarteras: '',
        chkgastogest:true,
        chkgastoprest:true,
        chkcomisionbroker:true
    });

    defaultOptima : OptimalWallet ={
        apalancamiento: 1,
        bajista: false,
        capitalinicial: 100000.0,
        idcartera: 0,
        nombre: '',
        valorLiquidativo: 100000,
        valorliquidativoTemp: 0.0,
        riesgomaximo: 50.0,
        tipocuenta: 'MARGEN',
        tiporiesgo: 'LIMITADO',
        riesgo: 1000.0,
        comisionbroker: 10.0,
        idmercado: 0,
        intervalotiempo: 2,
        prima: false,
        participacion: false,
        simulado: true,
        poderCompra: 100000,
        numeroReconfiguracion: 0,
        stopLoss: 20,
        profit: 10,
        capitales:[ 1000.0, 1000.0],
        fondosDisponibles: 100000,
        margen: 0,
        margenRequeridoPor: 30,
        controlMarginCall: 75.0,
        lista: 0,
        nOperaciones: 0,
        maxDiferenciaCierres: 0.0,
        rendimientoNeto: 0.0,
        rendimientomedioanual: 0.0,
        rendimientoacumuladoanual: 0.0,
        tasacrecimientoanualcompuesto: 0.0,
        periodosoperativa: 0,
        beneficioneto: 0.0,
        beneficionetoporcentual: 0.0,
        mayorretrocesodesdemaximo: 0.0,
        mayorretrocesodesdemaximoporcentual: 0.0,
        mediabeneficioperdidaporcentual: 0.0,
        sumaresiduosbeneficioperdidaporcentual: 0.0,
        volatilidadperiodo: 0.0,
        volatilidadanual: 0.0,
        mesesdd: 0,
        maximoretrocesoperiodo: 0.0,
        sumarrendimientosanuales: 0.0,
        prombeneficiointervalo: 0.0,
        prombeneficionintervaloporcentual: 0.0,
        sumatorio: false,
        coeficientevolatilidadanual: 1.0,
        ratiobeneficioriesgo: 0.0,
        modelodesde: '',
        efectivo: 100000.0,
        gastosGestionPor: 1.0,
        gastosPrestamoPor: 8.0,
        nRecalcular: 0,
        idModelo: 0,
        liquidativos: null,
        sincro: true,auto:false,
        idCarteras:[0,0,0,0,0],
        subCarteras: '',
        chkgastogest:true,
        chkgastoprest:true,
        chkcomisionbroker:true
    };
    public idMercado: number = 0;
    /** idModelo cargado en /models (?id=<idModelo> sin modo=analisis), 0 si no hay ninguno o estamos en modo análisis. */
    public idModeloActivo: number = 0;
    private rentabilidad = new BehaviorSubject<tablainterface[]>([]);
    private rendAnual = new BehaviorSubject<rendimientoanualinterface[]>([]);
    private riesgo = new BehaviorSubject<tablainterface[]>([]);
    private posSubjet = new BehaviorSubject<operationinterface[]>([]);

    private opeVentas = new BehaviorSubject<operationinterface[]>([]);
    private valoresLiquidativo = new BehaviorSubject<ValoresLiquidativos[]>([]);
    private valoresLatente = new BehaviorSubject<valorlatenteinterface[]>([]);
    carteraOptima = new BehaviorSubject<boolean>(false);
    public activatedCrearModelo= new BehaviorSubject<boolean>(false);
    operations = new BehaviorSubject<Operation[]>([]);
    private modelMercat = new BehaviorSubject<Model[]>([]);
    fechaFiltro = new BehaviorSubject<string>('');
    fechaBuscador = new BehaviorSubject<string>('');
    executeGrap = new BehaviorSubject<boolean>(false);
    activatedInforme = new BehaviorSubject<boolean>(false);
    isProc = new BehaviorSubject<boolean>(false);
    isACtual = new BehaviorSubject<boolean>(false);
    isshoW = new BehaviorSubject<boolean>(false);
    simularGestor = new BehaviorSubject<boolean>(false);
    activatedOptima = new BehaviorSubject<boolean>(false);
    /** Activo+modelo seleccionado desde la tabla Gestión/Contabilidad, para la gráfica embebida en Models (ver GestionComponent.habilitarGraficaEmbebida). */
    private modeloSeleccionadoGrafica = new BehaviorSubject<any>(null);

    operation$ = this.operations.asObservable();
    ventas$ = this.opeVentas.asObservable();
    valoresliquidativos$ = this.valoresLiquidativo.asObservable();
    valoreslatente$ = this.valoresLatente.asObservable();
    isLoadCartera$ = this.carteraOptima.asObservable();
    valRentabilidad$ = this.rentabilidad.asObservable();
    valRendAnual$ = this.rendAnual.asObservable();
    valRiesgo$ = this.riesgo.asObservable();
    valPos$= this.posSubjet.asObservable();
    valFechaFiltro$ = this.fechaFiltro.asObservable();
    valfechaBuscador$ =this.fechaBuscador.asObservable();
    valModeloMercado$ = this.modelMercat.asObservable();
    valformdata$ = this.formdata.asObservable();
    valexecuteGrap$ = this.executeGrap.asObservable();
    valoptimaWallet$= this.optimalWallet.asObservable();
    valIsProc$= this.isProc.asObservable();
    valisACtual$ = this.isACtual.asObservable();
    idMercado$ = new BehaviorSubject<number>(this.idMercado);
    /** Emite cada cambio de idModeloActivo (p. ej. al generar un modelo nuevo) para que la gráfica embebida se limpie. */
    idModeloActivo$ = new BehaviorSubject<number>(this.idModeloActivo);
    modeloSeleccionadoGrafica$ = this.modeloSeleccionadoGrafica.asObservable();

    valactivatedOptima$ = this.activatedOptima.asObservable().pipe(
        distinctUntilChanged()
      );
   
    valsimularGestor$ = this.simularGestor.asObservable().pipe(
        distinctUntilChanged()
      );

    valisshoW$ = this.isshoW.asObservable().pipe(
        distinctUntilChanged()
      );
    valactivatedInforme$ = this.activatedInforme.asObservable().pipe(
        distinctUntilChanged()
      );

    public formDataWallet: FormDataInterface = {

    }

    updateactivatedOptima(value: boolean): void {
        this.activatedOptima.next(value);
    }

    updatesimularGestor(value: boolean): void {
        this.simularGestor.next(value);
    }

    updateaisshoW(value: boolean): void {
        this.isshoW.next(value);
    }

    updateIdMercado(idMercado: number): void {
        this.idMercado = idMercado;
        this.idMercado$.next(idMercado);
    }

    updateIdModeloActivo(id: number): void {
        this.idModeloActivo = id;
        this.idModeloActivo$.next(id);
    }

    updateactivatedInforme(value: boolean): void {
        this.activatedInforme.next(value);
    }

    updateIsProc(value: boolean): void {
          this.isProc.next(value);
      }

    getDefaultOptima(){
        return this.defaultOptima;
    }
    
      updateIsACtual(value: boolean): void {
          this.isACtual.next(value);
      }

    getFormdata(){
        return this.formdata.asObservable();
    }

    getModelMercat(){
        return this.modelMercat.asObservable();
    }

    updateOptimaWallet(optima: any){
        this.optimalWallet.next(optima);
    }

    updateFormdata(newform: Interfaceformdata){
        this.formdata.next(newform);
    }

    updateOperation(newope: any){
        this.operations.next(newope);
    }

    updateValoresLiquidativos(valores: any){
        this.valoresLiquidativo.next(valores);
    }

    updateMod(newMod: Model[]){
        this.modelMercat.next(newMod);
    }

    updateCarteraoptima(){
        const currentValue = !this.carteraOptima.getValue();
        this.carteraOptima.next(currentValue);
    }
    updateExecuteGrap(data: boolean){
        this.executeGrap.next(data);
    }
    
    updateopeVentas(valores: any){
        this.opeVentas.next(valores);
    }
    updateValoresLatente(valores: any){
        this.valoresLatente.next(valores);
    }
    updateValRentabilidad(valores: any){
        this.rentabilidad.next(valores);
    }
    updateValRiesgo(valores: any){
        this.riesgo.next(valores);
    }
    updateValRendAnual(valores: any){
        this.rendAnual.next(valores);
    }

    updateValPos (valores: any){
        this.posSubjet.next(valores);
    }

    updateFechaFiltro (valores: any){
        this.fechaFiltro.next(valores);   
    }

    updatefechaBuscador(valores: any){
        this.fechaBuscador.next(valores);
    }

    updateModeloSeleccionadoGrafica(data: any){
        this.modeloSeleccionadoGrafica.next(data);
    }

    public loadIndicatorTypes() {
        return new Promise((resolve, reject) => {
            this.apiService
                .apiPost('parametricaparamodelos', true, {}, 2)
                .then((response) => {
                    resolve(response);
                  //  console.log("XXXXXXXXXXX :",response);
                })
                .catch((error) => {
                    this.errorModel =
                        'Error de conexión al servidor, intente nuevamente';
                    this.loadingModel = false;
                    reject(error);
                });
        });
    }
    public loadIndicatorTypesIA() {
        return new Promise((resolve, reject) => {
            this.apiService
                .apiGet2('ia/get_indicators')
                .then((response) => {
                    resolve(response);
                  //  console.log("XXXXXXXXXXX :",response);
                })
                .catch((error) => {
                    this.errorModel =
                        'Error de conexión al servidor, intente nuevamente';
                    this.loadingModel = false;
                    reject(error);
                });
        });
    }
    public walletAnalysis(params: string) {
        return new Promise((resolve, reject) => {
            this.apiService
                .apiGetCors(`RecalcularCartera?`, true, params, 2)
                .then((response: any) => {
                    this.orderActivities.emit(response);
                    resolve(response);
                })
                .catch((error) => {
                    this.errorModel =
                        'Error de conexión al servidor, intente nuevamente';
                    this.loadingModel = false;
                    reject(error);
                });
        });
    }
}

export interface FormDataInterface {
    [key: string]: any,
}

export interface GestionInterface {
    nombreCompania: string;
    isooper: string;
    fechaOperacion: string;
    tipooperacion: string;
    precioentradareal: number;
    preciosalidareal: number;
    stoplossinicial: number;
}
